















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class myvideo extends Vue {
  @Prop({}) videoInfo!: any;
  $video: any;
  myplayer: any;
  imgCover: any;
  playUrl: any;
  mounted() {
    this.$nextTick(() => {
      this.initVideo();
    });
  }
  closeVideo() {
    this.myplayer.dispose();
    this.$emit("changeVideo", false);
  }
  initVideo() {
    let that = this;
    this.myplayer = this.$video(
      "myvideo",
      {
        controls: true,
        autoplay: true,
        poster: this.videoInfo.videoCover,
        sources: [
          {
            src: this.videoInfo.playUrl,
          },
        ],
      },
      function onPlayerReady() {
        console.log("播放器已经准备好了!");
      }
    );
  }
}
